import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    loading: 'Loading...',
    noData: 'No data available',
    
    // Audit Log
    auditLog: 'Audit Log',
    auditLogDescription: 'Track all system activities and user actions',
    allActions: 'All Actions',
    allResources: 'All Resources',
    dateRange: 'Date Range',
    searchPlaceholder: 'Search by user or details...',
    totalActions: 'Total Actions',
    todayActivity: "Today's Activity",
    uniqueUsers: 'Unique Users',
    exportLogs: 'Export Logs',
    
    // Documents
    documents: 'Documents',
    uploadDocument: 'Upload Document',
    deleteDocument: 'Delete Document',
    viewDocument: 'View Document',
    
    // Chat
    chat: 'Chat',
    askQuestion: 'Ask a question...',
    
    // Reports
    reports: 'Reports',
    generateReport: 'Generate Report',
  },
  ms: {
    // Malaysian
    save: 'Simpan',
    cancel: 'Batal',
    delete: 'Padam',
    edit: 'Sunting',
    search: 'Cari',
    filter: 'Tapis',
    export: 'Eksport',
    loading: 'Memuatkan...',
    noData: 'Tiada data',
    
    auditLog: 'Log Audit',
    auditLogDescription: 'Jejaki semua aktiviti sistem dan tindakan pengguna',
    allActions: 'Semua Tindakan',
    allResources: 'Semua Sumber',
    dateRange: 'Julat Tarikh',
    searchPlaceholder: 'Cari mengikut pengguna atau butiran...',
    totalActions: 'Jumlah Tindakan',
    todayActivity: 'Aktiviti Hari Ini',
    uniqueUsers: 'Pengguna Unik',
    exportLogs: 'Eksport Log',
    
    documents: 'Dokumen',
    uploadDocument: 'Muat Naik Dokumen',
    deleteDocument: 'Padam Dokumen',
    viewDocument: 'Lihat Dokumen',
    
    chat: 'Sembang',
    askQuestion: 'Tanya soalan...',
    
    reports: 'Laporan',
    generateReport: 'Jana Laporan',
  }
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('appLanguage');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('appLanguage', language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'ms' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    // Return default values if not in provider
    return { language: 'en', setLanguage: () => {}, toggleLanguage: () => {} };
  }
  return context;
};

// Language options for dropdown
export const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'ms', name: 'Bahasa Malaysia', flag: '🇲🇾' },
];

export { translations };
export default LanguageContext;
